import { ledgerService } from '../../services'

export const notifications = {
  namespaced: true,
  state: {
    flights: [],
    count: 0,
    loading: false,
    lastFetched: null
  },
  mutations: {
    SET_NOTIFICATIONS (state, { flights, count }) {
      state.flights = flights
      state.count = count
      state.lastFetched = new Date()
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    fetchUpcoming ({ commit }) {
      commit('SET_LOADING', true)
      return ledgerService.getUpcomingNotifications().then(data => {
        commit('SET_NOTIFICATIONS', { flights: data.flights, count: data.count })
        commit('SET_LOADING', false)
      }).catch(() => {
        commit('SET_LOADING', false)
      })
    }
  }
}
